/* eslint-disable no-undef */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Header, Responsive, Item } from 'semantic-ui-react';
import messages from './messages';

import img1 from './assets/1-online-stores.svg';
import img2 from './assets/2-no-hidden-fees.svg';
import img3 from './assets/3-huge-discount.svg';
import img4 from './assets/4-cash-back.svg';

// eslint-disable-next-line react/prefer-stateless-function
class HeroMsg extends React.PureComponent {
  render() {
    const countryCode =
      this.props.currentUser && this.props.currentUser.country
        ? this.props.currentUser.country.iso_code
        : this.props.geo.countryCode;

    // const storeHeroMsg = (
    //   <div style={{ textAlign: 'center', marginBottom: '2em' }}>
    //     {this.props.large && (
    //       <Image
    //         style={{
    //           objectFit: 'contain',
    //           objectPosition: 'center',
    //           width: '100%',
    //           height: '100',
    //           padding: '18px',
    //           background: '#fff',
    //           marginBottom: '-1.5em',
    //           marginTop: '-1.5em',
    //         }}
    //         src="https://storage.googleapis.com/lynks/stores-logos/macys.png"
    //       />
    //     )}
    //     <Header style={{ fontSize: this.props.large ? '1.6em' : '1.35em' }}>
    //       Join and earn <span style={{ color: '#ee4109' }}>3% Cash Back</span>{' '}
    //       on every order you place with Lynks on Macy's.
    //     </Header>
    //     <p
    //       style={{
    //         color: 'rgba(0, 0, 0, 0.68)',
    //         fontSize: this.props.large ? '1.55em' : '1.3em',
    //         lineHeight: '1.3em',
    //       }}
    //     >
    //       Final price with big discounts on Item price, Shipping & Fees.
    //     </p>
    //     {!this.props.large && (
    //       <Image
    //         style={{
    //           objectFit: 'contain',
    //           objectPosition: 'center',
    //           width: '100%',
    //           height: '80px',
    //           padding: '18px',
    //           background: '#fff',
    //           marginBottom: '-1.5em',
    //           marginTop: '-1.5em',
    //         }}
    //         src="https://storage.googleapis.com/lynks/stores-logos/macys.png"
    //       />
    //     )}
    //   </div>
    // );

    const normalHeroMsg = (
      <div
        style={{
          textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
          marginBottom: '2em',
        }}
      >
        <Header style={{ fontSize: this.props.large ? '1.8em' : '1.35em' }}>
          <FormattedMessage {...messages.header} />
        </Header>
        <p
          style={{
            color: 'rgba(0, 0, 0, 0.68)',
            fontSize: this.props.large ? '1.55em' : '1.3em',
            lineHeight: '1.3em',
            marginBottom: '2em',
          }}
        >
          <FormattedMessage
            {...messages.subheader}
            values={{
              country: `${getCountryFromIso(
                this.props.intl.locale,
                countryCode
              )}`,
              currency: `${getHeaderCurrencyFromIso(
                this.props.intl.locale,
                countryCode
              )}`,
            }}
          />
        </p>

        <Responsive minWidth={768}>
          <Item.Group>
            <Item>
              <Item.Image size="mini" src={img1} />

              <Item.Content>
                <Item.Header>
                  <FormattedMessage {...messages.h1} />
                </Item.Header>
                <Item.Description>
                  <FormattedMessage {...messages.p1} />
                </Item.Description>
              </Item.Content>
            </Item>

            <Item>
              <Item.Image size="mini" src={img2} />

              <Item.Content>
                <Item.Header>
                  <FormattedMessage {...messages.h2} />
                </Item.Header>
                <Item.Description>
                  <FormattedMessage {...messages.p2} />
                </Item.Description>
              </Item.Content>
            </Item>

            <Item>
              <Item.Image size="mini" src={img3} />

              <Item.Content>
                <Item.Header>
                  <FormattedMessage {...messages.h3} />
                </Item.Header>
                <Item.Description>
                  <FormattedMessage {...messages.p3} />
                </Item.Description>
              </Item.Content>
            </Item>

            <Item>
              <Item.Image size="mini" src={img4} />

              <Item.Content>
                <Item.Header>
                  <FormattedMessage {...messages.h4} />
                </Item.Header>
                <Item.Description>
                  <FormattedMessage {...messages.p4} />
                </Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Responsive>
      </div>
    );

    return normalHeroMsg;
  }
}

export default HeroMsg;



// WEBPACK FOOTER //
// ./app/containers/Auth/HeroMsg.js